import { XCenteredAbsolute, motion } from "~/utils";
import { Dreadnought, Troop, UnitType } from "~/business";
import { usePlayerColor } from "~/jsx/hook/usePlayerColor";
import { Spacing } from "~/jsx/theme";
import { XPackBy } from "./XPackBy";
import { XPlayerTroop } from "./XPlayerTroop";
import { XTroop } from "./XTroop";
import { XTypography } from "./XTypography";
import { XDreadnought } from "./svg";

export const XPlayerUnits = ({
  width,
  units,
  playerId,
  type,
  variant,
}: {
  width: number;
  units: Troop[] | Dreadnought[];
  playerId: string;
  type: UnitType;
  variant?: "compact";
}) => {
  const amount = units.length;
  const color = usePlayerColor(playerId);
  if (variant === "compact") {
    if (amount === 0) return null;
    return (
      <div>
        {type === "troop" ? (
          <XPlayerTroop width={width} playerId={playerId} />
        ) : (
          <XDreadnought width={width} color={color ?? undefined} />
        )}
        <XCenteredAbsolute>
          <XTypography>{amount}</XTypography>
        </XCenteredAbsolute>
      </div>
    );
  }

  if (amount <= 0 || amount >= 5) {
    return (
      <div
        style={{
          display: "flex",
          gap: Spacing.px4,
          alignItems: "center",
        }}
      >
        <XTypography>{amount}</XTypography>
        {type === "troop" ? (
          <XPlayerTroop width={width} playerId={amount === 0 ? "" : playerId} />
        ) : (
          <XDreadnought width={width} color={color ?? undefined} />
        )}
      </div>
    );
  } else {
    return (
      <XPackBy packSize={2}>
        {units.map((unit) => (
          <motion.div layoutId={unit.id} key={unit.id}>
            {type === "troop" ? (
              <XTroop width={width} color={color ?? undefined} />
            ) : (
              <XDreadnought width={width} color={color ?? undefined} />
            )}
          </motion.div>
        ))}
      </XPackBy>
    );
  }
};
